window.dataLayer = window.dataLayer || [];
window.PGdataLayer = window.PGdataLayer || {};

window.PGdataLayer = {
    "GTM": {
		
    },
    "user": {
		"marketingProgramNbr": "448",
		"sourceID": "15226",
		"id": "",
		"email": "",
		"countryCode": "USA"
	},
	"ecomm": {
		"products": [],
	},
    "page": {
        'title': document.title,
        'url': window.location.href
    }
};

window.__PG_ENV_CONFIG = null;

window.addEventListener("message", function (event) {
  if (!(event.origin === "null" || event.origin === window.location.origin))
    return;

  if (
    event.data?.source === "shopify-customer-events" &&
    event.data?.type === "PG_ENV_CONFIG"
  ) {

    window.__PG_ENV_CONFIG = event.data.payload;

    // enrich PGdataLayer
    window.PGdataLayer.GTM.SiteEnvironment = window.__PG_ENV_CONFIG.SiteEnvironment;
    window.PGdataLayer.GTM.SiteStatus = window.__PG_ENV_CONFIG.SiteStatus;
    window.PGdataLayer.GTM.SiteTouchpoint = window.__PG_ENV_CONFIG.SiteTouchpoint;
    window.PGdataLayer.GTM.SiteCountry = window.__PG_ENV_CONFIG.SiteCountry;
    window.PGdataLayer.GTM.SiteLanguage = window.__PG_ENV_CONFIG.SiteLanguage;
    window.PGdataLayer.GTM.SiteLocale = window.__PG_ENV_CONFIG.SiteLocale;
    window.PGdataLayer.GTM.SiteHost = window.__PG_ENV_CONFIG.SiteHost;
    window.PGdataLayer.GTM.SiteTechnicalAgency = window.__PG_ENV_CONFIG.SiteTechnicalAgency;
    window.PGdataLayer.GTM.SiteLocalContainer = window.__PG_ENV_CONFIG.SiteLocalContainer;
    window.PGdataLayer.GTM.GoogleAnalyticsGA4MeasurementID = window.__PG_ENV_CONFIG.GoogleAnalyticsGA4MeasurementID;
    window.PGdataLayer.GTM.GoogleAnalyticsSiteSpeedSampleRate = window.__PG_ENV_CONFIG.GoogleAnalyticsSiteSpeedSampleRate;
    window.PGdataLayer.GTM.GoogleAnalyticsOptimizeContainerID = window.__PG_ENV_CONFIG.GoogleAnalyticsOptimizeContainerID;
    window.PGdataLayer.GTM.GoogleAnalyticsReportingView = window.__PG_ENV_CONFIG.GoogleAnalyticsReportingView;
    window.PGdataLayer.GTM.ConsentOverlay = window.__PG_ENV_CONFIG.ConsentOverlay;
    window.PGdataLayer.GTM.SitePrivacyProtection = window.__PG_ENV_CONFIG.SitePrivacyProtection;
    window.PGdataLayer.GTM.FacebookRemarketingID = window.__PG_ENV_CONFIG.FacebookRemarketingID;
    window.PGdataLayer.GTM.GoogleAnalyticsLocal = window.__PG_ENV_CONFIG.GoogleAnalyticsLocal;
    window.PGdataLayer.GTM.ConsentOverlayID = window.__PG_ENV_CONFIG.ConsentOverlayID;
    window.PGdataLayer.GTM.FacebookStandardEvents = window.__PG_ENV_CONFIG.FacebookStandardEvents;
    window.PGdataLayer.GTM.Rudderstack = window.__PG_ENV_CONFIG.Rudderstack;
    window.PGdataLayer.GTM.SiteCountryISO3 = window.__PG_ENV_CONFIG.SiteCountryISO3;
    window.PGdataLayer.GTM.Segment = window.__PG_ENV_CONFIG.Segment;


    // now safe to bootstrap GTM — but delay until page is idle / user interacts
    scheduleGTM(window.__PG_ENV_CONFIG.gtmContainerId);
  }

});



function scheduleGTM(containerId) {
  if (!containerId || window.__gtmLoaded) return;

  // Fire GTM on first user interaction OR after a generous idle timeout
  let events = ['mouseover', 'keydown', 'touchstart', 'scroll'];
  let fired = false;

  function trigger() {
    if (fired) return;
    fired = true;
    events.forEach(function(e) { window.removeEventListener(e, trigger, { capture: true }); });
    loadGTM(containerId);
  }

  events.forEach(function(e) { window.addEventListener(e, trigger, { once: true, capture: true, passive: true }); });

  // Real users who interact get GTM instantly via the event listeners above.
  setTimeout(trigger, 8000);
}


function loadGTM(containerId) {
  if (!containerId || window.__gtmLoaded) return;
  window.__gtmLoaded = true;

  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),
        dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer',containerId);
}


